import React, { useState, useEffect } from "react";
import { getobj } from "../../apicall/apicall";
import { Card } from "@mui/material";
import { headerStyle } from "../../style/style";
import ReplacedDeviceList from "../ReplacedDeviceList";
import ViewDetails from "../Dialogs/ViewDetails";


export default function CustomerReplacedDevice(props) {
  const [page, setPage] = useState(1);
  const [devices, setDevices] = useState([]);
  const [loader, setLoader] = useState(true);
  const [totalPage, setTotalPage] = useState(1);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [selectedDevice, setSelectedDevice] = useState(null);

  useEffect(() => {
    const getDevices = async () => {
      let url;
      setLoader(true);
      if (props.search === "") {
        url =
          process.env.REACT_APP_ZEWA_URL +
          "replace-device/devices/?page=" +
          page;
      } else {
        setPage(1);
        url =
          process.env.REACT_APP_ZEWA_URL +
          "replace-device/devices/?page=1&search=" +
          props.search;
      }

      const res = await getobj(url);
      setDevices(res.results);
      if (res.results.length > 0) {
        if (res.count % 5 > 0) {
          setTotalPage(Math.floor(res.count / 5) + 1);
        } else {
          setTotalPage(Math.floor(res.count / 5));
        }
      }
      setLoader(false);
    };

    getDevices();
  }, [page, props.search]);
  return (
    <div>
      {loader ? (
        <Card sx={headerStyle}>
          <img src="https://zewa-logo-bucket.s3.amazonaws.com/logo/Spinner-1s-200px.gif" alt="loading..." />
        </Card>
      ) : devices.length > 0 ? (
        <ReplacedDeviceList
          devices={devices}
          page={page}
          setPage={setPage}
          totalPage={totalPage}
          openViewModal={openViewModal}
          setOpenViewModal={setOpenViewModal}
          setSelectedDevice={setSelectedDevice}
        />
      ) : (
        <Card sx={headerStyle}>No Replaced Device Found</Card>
      )}
      {openViewModal && (
        <ViewDetails
          open={openViewModal}
          setOpen={setOpenViewModal}
          selectedDevice={selectedDevice}
        />
      )}
    </div>
  );
}
